import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "../Pages/Views/Employee/CheckInOut/checkInPage.module.less";
import {
    Body_16_Coral_Primary_Regular_16,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {useMemo} from "react";
import {GPSWait} from "@UI/illustrationsSvg/GPSWait.tsx";
import cn from "classnames";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";

interface GpsProps {
    coords: {
        longitude: number
        latitude: number
    }
    placeName?: string
    onClose?: () => void
}

export const GPSSuccessModal = ({coords, placeName, onClose}: GpsProps) => {

    const eventCoords = useMemo(() => {
        if (!coords.latitude || !coords?.longitude) return "—,—";
        const lang = coords.latitude.toFixed(3);
        const long = coords.longitude.toFixed(3);
        return `${lang},${long}`;
    }, [coords])
    return (
        <Stack grow alignItems={"center"} justifyContent={"center"} direction={"column"} gap={16}
               className={styles.checkPopup}>
            <GPSWait/>
            <Stack direction={"column"} alignItems={"center"} style={{width: "272px"}}>
                <Stack className={styles.title} justifyContent={"center"}>
                    <Title_20_Coral_Strong_emphasis_20>
                        <Gt>The timestamp has been recorded!</Gt>
                    </Title_20_Coral_Strong_emphasis_20>
                </Stack>
                <Stack className={cn(styles.title, styles.coordsContent)} justifyContent={"center"}>
                    <Stack direction={"column"} alignItems={"flex-start"} className={styles.coorsTitles}>
                        <Body_16_Coral_Primary_Regular_16>
                            <Gt>Already acquired</Gt>
                        </Body_16_Coral_Primary_Regular_16>
                        <Body_16_Coral_Primary_Regular_16>
                            <Gt>Position name</Gt>
                        </Body_16_Coral_Primary_Regular_16>
                    </Stack>
                    <Stack direction={"column"} alignItems={"flex-start"} className={styles.coorsValues}>
                        <Body_16_Coral_Primary_Regular_16>
                            {eventCoords}
                        </Body_16_Coral_Primary_Regular_16>
                        <Body_16_Coral_Primary_Regular_16>
                            {placeName || <Gt>Unknown location</Gt>}
                        </Body_16_Coral_Primary_Regular_16>
                    </Stack>

                </Stack>
            </Stack>
            <Button type={ButtonType.third}
                    onClick={onClose}><Gt>Close</Gt></Button>
        </Stack>
    )
}